var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"dat":_vm.campo})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }